import React, { FC } from 'react';
import { CoreRouter, LogoutRoute } from './utils/coreRouter';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import ResetPassword from '../pages/ResetPassword';
import TwoFactorAuth from '../pages/TwoFactorAuth';
import ProfileSettings from '../pages/ProfileSettings';
import SchoolsListing from '../pages/SchoolsListing';
import SchoolEdit from '../pages/SchoolEdit';
import SchoolDashboard from '../pages/Dashboard/SchoolDashboard';
import UsersListing from '../pages/UsersListing';
import UserEdit from '../pages/UserEdit';
import SurveysListing from '../pages/SurveysListing';
import SurveyEdit from '../pages/SurveyEdit';
import SurveyView from '../pages/SurveyView';
import IndicatorsListing from '../pages/IndicatorsListing';
import IndicatorCategoriesListing from '../pages/IndicatorCategoriesListing';
import EducationCenterIndicators from '../pages/EducationCenterIndicators';
import EducationDepartmentIndicators from '../pages/EducationDepartmentIndicators';
import ExamsListing from '../pages/ExamsListing';
import CompetitionDetail from '../pages/CompetitionDetail';
import IndicatorDataImport from '../pages/IndicatorDataImport';
import Help from '../pages/Help';
import IndicatorSchoolsStatus from '../pages/IndicatorSchoolsStatus';

const Routes: FC = () => (
    <CoreRouter routes={[
        { path: '/', component: Login, type: 'default' },
        { path: '/dashboard', component: Dashboard, type: 'auth' },
        { path: '/mokyklos', component: SchoolsListing, type: 'auth' },
        { path: '/mokykla/redagavimas', component: SchoolEdit, type: 'auth' },
        { path: '/mokykla/darbalaukis', component: SchoolDashboard, type: 'auth' },
        { path: '/profilio-nustatymai', component: ProfileSettings, type: 'auth' },
        { path: '/vartotojai', component: UsersListing, type: 'auth' },
        { path: '/vartotojas/redagavimas', component: UserEdit, type: 'auth' },
        { path: '/apklausos', component: SurveysListing, type: 'auth' },
        { path: '/apklausa/redagavimas', component: SurveyEdit, type: 'auth' },
        { path: '/apklausa/pildymas/:slug', component: SurveyView, type: 'default' },
        { path: '/rodikliai', component: IndicatorsListing, type: 'auth' },
        { path: '/rodikliu-kategorijos', component: IndicatorCategoriesListing, type: 'auth' },
        { path: '/svietimo-centro-rodikliai', component: EducationCenterIndicators, type: 'auth' },
        { path: '/svietimo-skyriaus-rodikliai', component: EducationDepartmentIndicators, type: 'auth' },
        { path: '/egzaminai', component: ExamsListing, type: 'auth' },
        { path: '/konkursas', component: CompetitionDetail, type: 'auth' },
        { path: '/duomenu-importavimas', component: IndicatorDataImport, type: 'auth' },
        { path: '/pagalba', component: Help, type: 'auth' },
        { path: '/rodiklio-mokyklu-statusas', component: IndicatorSchoolsStatus, type: 'auth' },
        { path: '/reset-password/:token/:email', component: ResetPassword, type: 'default' },
        { path: '/two-factor', component: TwoFactorAuth, type: 'default' },
        { path: '/logout', component: LogoutRoute, type: 'default' },
        { path: '/auth/dashboard', component: Dashboard, type: 'auth' },
    ]} />
);

export default Routes;
